import { observer } from "mobx-react-lite";
import { NavigationControl } from "react-map-gl";

function ZoomMapControl() {
    return (
        <NavigationControl showCompass visualizePitch style={{
            border: "1px solid black",
        }} />
    );
}

export default observer(ZoomMapControl);